import { render, staticRenderFns } from "./treasureBox.vue?vue&type=template&id=71962423&scoped=true"
import script from "./treasureBox.vue?vue&type=script&lang=js"
export * from "./treasureBox.vue?vue&type=script&lang=js"
import style0 from "./treasureBox.vue?vue&type=style&index=0&id=71962423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71962423",
  null
  
)

export default component.exports